import { api } from '@ezugi/utils/http/httpRequest';

import { GET_PLAYER_HISTORY_URL, GET_PLAYER_DAY_HISTORY_URL } from '../../../endpoints';

type PlayerHistoryResponse = {
  result: unknown;
};

export const getPlayerHistory = (
  params: Record<string, string>
) => api.get<PlayerHistoryResponse>(
  `${GET_PLAYER_HISTORY_URL}?${new URLSearchParams(params)}`
);

type PlayerDayHistoryResponse = {
  result: unknown;
};

export const getPlayerDayHistory = (
  params: Record<string, string>
) => api.get<PlayerDayHistoryResponse>(
  `${GET_PLAYER_DAY_HISTORY_URL}?${new URLSearchParams(params)}`
);
